import { library, dom } from '@fortawesome/fontawesome-svg-core';

// Solid icon imports
//
// Selectively import the icons you want to bundle. Importing `fas` is not
// advised as this will bundle all solid style icons and result in bundle
// bloat.

import {
  faSearch,
  faTimes,
  faCheck,
  faExternalLinkAlt,
  faChevronUp,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faBars,
  faPlus,
  faMinus,
  faFile,
  faFileWord,
  faFilePdf,
  faEnvelope,
  faBell,
  faExclamationTriangle,
  faPrint,
  faShareAlt,
  faCalendar,
  faArrowRight,
} from '@fortawesome/pro-solid-svg-icons';

// Brand icon imports
//
// Selectively import the icons you want to bundle. Importing `fab` is not
// advised as this will bundle all solid style icons and result in bundle
// bloat.

import {
  faFacebookSquare,
  faLinkedin,
  faTwitterSquare,
  faYoutubeSquare,
  faPinterestSquare,
} from '@fortawesome/free-brands-svg-icons';

// Add imported icons to the library for Font Awesome to monitor and replace.

library.add([
  faSearch,
  faTimes,
  faCheck,
  faExternalLinkAlt,
  faChevronUp,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faBars,
  faPlus,
  faMinus,
  faFile,
  faFileWord,
  faFilePdf,
  faEnvelope,
  faBell,
  faExclamationTriangle,
  faPrint,
  faShareAlt,
  faCalendar,
  faFacebookSquare,
  faLinkedin,
  faTwitterSquare,
  faYoutubeSquare,
  faPinterestSquare,
  faArrowRight,
]);

export default function initFontAwesome() {
  // Replace any existing <i> tags with <svg> and set up a MutationObserver to
  // continue doing this as the DOM changes.
  dom.watch();
}
